import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label } from 'ng2-charts';

@Component({
  selector: 'app-dw',
  templateUrl: './dw.component.html',
  styleUrls: ['./dw.component.css']
})
export class DwComponent implements OnInit {
  public doughnutChartLabels: Label[] = [];
  public doughnutChartData: MultiDataSet = [
  [75, 25],
];

public chartColors: Array<any>=[
  {
    backgroundColor:['#6076df', '#eeeeee'],
    hoverBackgroundColor:['#6076df', '#eeeeee'],
    borderWidth:0,
  }
];

public doughnutChartType: ChartType = 'doughnut';

  constructor() { }

  ngOnInit() {
  }
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }
}
